(function () {
  function initGallery() {
    var gallery = document.getElementById('GalleryViewer-template--25528043372811__main');
    if (!gallery) {
      var galleries = document.querySelectorAll('[id^="GalleryViewer-"]');
      if (galleries.length) gallery = galleries[0];
    }
    if (!gallery) return false;

    var list = gallery.querySelector('.product__media-list');
    var counter = gallery.querySelector('.slider-counter');
    var btnPrev = gallery.querySelector('.slider-button--prev');
    var btnNext = gallery.querySelector('.slider-button--next');
    if (!list || !counter) return false;

    var slides = list.querySelectorAll('.product__media-item');
    var total = slides.length;
    if (total < 2) return true;

    counter.innerHTML = '';
    var dots = [];
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('span');
      dot.style.cssText = 'display:inline-block;width:6px;height:6px;border-radius:50%;background:#d4d4d8;transition:all 0.2s;flex-shrink:0;';
      counter.appendChild(dot);
      dots.push(dot);
    }

    function updateDots(idx) {
      dots.forEach(function (d, i) {
        if (i === idx) {
          d.style.background = '#f36d21';
          d.style.width = '20px';
          d.style.borderRadius = '3px';
        } else {
          d.style.background = '#d4d4d8';
          d.style.width = '6px';
          d.style.borderRadius = '50%';
        }
      });
    }

    updateDots(0);

    list.addEventListener('scroll', function () {
      var slideWidth = list.querySelector('.product__media-item').offsetWidth;
      var idx = Math.round(list.scrollLeft / slideWidth);
      updateDots(idx);
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        var slideWidth = list.querySelector('.product__media-item').offsetWidth;
        var idx = Math.round(list.scrollLeft / slideWidth);
        if (idx > 0) list.scrollTo({ left: (idx - 1) * slideWidth, behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        var slideWidth = list.querySelector('.product__media-item').offsetWidth;
        var idx = Math.round(list.scrollLeft / slideWidth);
        if (idx < total - 1) list.scrollTo({ left: (idx + 1) * slideWidth, behavior: 'smooth' });
      });
    }

    return true;
  }

  var tries = 0;
  function attempt() {
    if (initGallery()) return;
    tries++;
    if (tries < 20) setTimeout(attempt, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }
})();